import Postback from './Postback'

export default {
  namespaced: true,
  modules: {
    Postback
  }
}
